"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuLocationListener = MenuLocationListener;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const MenuContext_1 = require("./MenuContext");
function MenuLocationListener() {
    const location = (0, react_router_dom_1.useLocation)();
    const { setMenuItem } = (0, MenuContext_1.useMenu)();
    (0, react_1.useEffect)(() => {
        if (location.pathname == "/reports/marktdaten") {
            setMenuItem("marktdaten");
        }
        else if (location.pathname == "/reports/boerse") {
            setMenuItem("boerse");
        }
        else if (location.pathname == "/reports/preise") {
            setMenuItem("preise");
        }
        else if (location.pathname == "/reports/milch") {
            setMenuItem("milch");
        }
        else if (location.pathname == "/reports/flaechen") {
            setMenuItem("flaechen");
        }
        else if (location.pathname == "/reports/info") {
            setMenuItem("info");
        }
        else if (location.pathname == "/dashboards") {
            setMenuItem("dashboards");
        }
        else if (location.pathname == "/") {
            setMenuItem("home");
        }
    }, [location]);
    return null;
}
